import parseAgentState from '../utils/parse-agent-state';

const initialState = {
  modalOpen: false,
  timezone: false,
  addr: false,
  muted: false,
  status: 'noauth',
  agentState: parseAgentState('n/a'),
  ccpAgentState: 'n/a',
  duration: 0,
  firstCall: true,
  error: '',
  contactId: '',
  loginAttempt: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CALL_ID':
      return { ...state, contactId: action.id };
    case 'SET_CALL_ERROR':
      return { ...state, error: action.error };
    case 'MARK_FIRST_CALL':
      return { ...state, firstCall: false };
    case 'SET_CALL_DURATION':
      return { ...state, duration: action.duration };
    case 'UPDATE_AGENT_STATE': {
      const ccpAgentState = action.newState;
      const agentState = parseAgentState(ccpAgentState);
      // console.log('!!! UPDATE_AGENT_STATE', agentState, ccpAgentState);
      return { ...state, agentState, ccpAgentState };
    }
    case 'UPDATE_CALL_STATUS':
      // console.log('!!! UPDATE_CALL_STATUS', action.status);
      return { ...state, status: action.status };
    case 'MUTE_CALL':
      return { ...state, muted: true };
    case 'UNMUTE_CALL':
      return { ...state, muted: false };
    case 'UPDATE_PRETTY_ADDR':
      return { ...state, addr: action.addr };
    case 'TOGGLE_CALL_MODAL':
      return { ...state, modalOpen: !state.modalOpen, error: '' };
    case 'UPDATE_TIMEZONE':
      return { ...state, timezone: action.timeZoneId };
    case 'CLEAR_TELEPHONY':
      return { ...initialState };
    case 'SET_CONNECT_LOGIN_STATUS':
      return { ...state, loginAttempt: action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
